import { TriggerTypes } from '../../architecture/enums/TriggerTypes';
import { Trigger } from './Trigger';

export class NodeTrigger extends Trigger {
  constructor() {
    super();
    this.type = TriggerTypes.Node;
  }
}
